import { modelContent } from './article'
import { modelMedia } from '~/models/content/media.js'

export const modelLightweightAthlete = (athlete) => {
  return {
    id: athlete.id,
    title: athlete.title,
    subtitle: athlete.subtitle,
    slug: athlete.slug,
    fullSlug: `/explore/pro-team/${athlete.slug}`,
    category: {
      slug: 'pro-team',
      title: 'Team SunGod',
      fullSlug: '/explore/pro-team'
    },
    isNew: false,
    isProTeamPage: true,
    media: modelMedia(athlete.media)
  }
}

export const modelAthlete = (athlete) => {
  return {
    ...modelLightweightAthlete(athlete),
    hero: {
      title: athlete.title,
      media: {
        image: athlete.image || {},
        mobileImageUrl: athlete.mobileImage?.src || null,
        videoUrl: athlete.video?.src || null,
        mobileVideoUrl: athlete.mobileVideo?.src || null
      },
      sport: athlete.sport,
      sportSubtitle: athlete.sportSubtitle,
      subtitleGradient: athlete.subtitleGradient.toLowerCase(),
      overlayOpacity: athlete.overlayOpacity
    },
    content: modelContent(athlete.content),
    metaBlock: {
      dateOfBirth: athlete.dateOfBirth,
      items: athlete.metaItems.map(metaItem => ({
        title: metaItem.title,
        copy: metaItem.copy
      })),
      socialHandle: athlete.socialHandle,
      socialHandleType: athlete.socialHandleType
    },
    meta: athlete.meta,
    tags: athlete.tags.map(tag => tag.id)
  }
}
